import { ReactNode, useState } from 'react';
import { Box, Stack } from '@mui/material';
import MainHeader from './MainHeader';
import { Styles, SxProp, mergeSx } from '@t2c/shared-fe';
import SideDrawer from '../../dashboard/side-drawer/SideDrawer';
import FooterButtons from './FooterButtons';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  wrapperSx?: SxProp;
  containerSxProps?: SxProp;
  childrenWrapperSx?: SxProp;
  backBtnHandler?: (isPreviousRoute: boolean) => void;
};

export function DashboardNew({
  children,
  wrapperSx,
  containerSxProps,
  childrenWrapperSx,
  backBtnHandler,
}: Props) {
  const [isFullWdithHeader, setIsFullWdithHeader] = useState(false);
  return (
    <Stack sx={style.container}>
      <MainHeader backBtnHandler={backBtnHandler} isFullWdithHeader={isFullWdithHeader} />
      <Box sx={mergeSx(style.childWrapper, wrapperSx)}>
        <SideDrawer
          containerSxProps={containerSxProps}
          childrenWrapperSx={childrenWrapperSx}
          setIsFullWdithHeader={setIsFullWdithHeader}
        >
          {children}
        </SideDrawer>
      </Box>
      <FooterButtons />
    </Stack>
  );
}

const style: Styles = {
  container: {
    minHeight: '100vh',
  },
  childWrapper: {
    mt: { xs: 13, md: 8 },
    flexGrow: 1,
  },
};
